import { FC, HTMLAttributes, ReactNode } from 'react';

import { StyledSection } from './Section.styles';

export interface Props extends HTMLAttributes<HTMLElement> {
	subdued?: boolean;
	children?: ReactNode;
}

export const Section: FC<Props> = ({ subdued, children, ...other }) => (
	<StyledSection subdued={subdued} {...other}>
		{children}
	</StyledSection>
);
